import { useQuery } from 'react-apollo';

import GraphqlError from '~/components/GraphqlError';
import EventsList from '~/components/Sidebar/EventsList';
import { paginateData } from '~/lib/graphql/pagination';

import query from './query.graphql';

const initialPageSize = 100;
const perPage = 50;
// NOTE https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/core/networkStatus.ts#L22
const networkIsFetchingMore = 3;

const ListEvents = ({ person, className }) => {
  const [type, setType] = useState();

  const variables = {
    first: initialPageSize,
    id: person.id,
    ...(type && { type }),
  };

  const {
    data = {
      person: {},
    },
    error,
    fetchMore,
    loading,
    networkStatus,
    refetch,
  } = useQuery(query, { variables, notifyOnNetworkStatusChange: true });

  if (error) {
    return <GraphqlError error={error} loading={loading} refetch={refetch} />;
  }

  const { events, eventsHasNextPage, eventsEndCursor } = paginateData(
    data.person,
    { fields: ['events'] },
  );

  const { eventTypes = [] } = data;

  const firstPageLoading = loading && networkStatus !== networkIsFetchingMore;

  return (
    <EventsList
      className={className}
      events={events}
      eventTypes={eventTypes}
      hasNextPage={eventsHasNextPage}
      id={person.id}
      loading={firstPageLoading}
      loadingMore={loading}
      onFilter={(type) => setType(type)}
      onLoadMore={() => {
        if (loading) {
          return;
        }

        fetchMore({
          variables: {
            ...variables,
            after: eventsEndCursor,
            first: perPage,
          },

          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
              return prev;
            }

            fetchMoreResult.person.events.edges = [
              ...prev.person.events.edges,
              ...fetchMoreResult.person.events.edges,
            ];

            return fetchMoreResult;
          },
        });
      }}
    />
  );
};

ListEvents.propTypes = {
  className: PropTypes.string,
  person: PropTypes.object.isRequired,
};

export default ListEvents;
